import React from 'react';
import { v1 as uuidv1 } from 'uuid';

export default function SimpleMultiSelect({
  options = [],
  selectedValues = [],
  onChange = () => {},
  nameMapping = null,
  showCount = false
}) {
    const toggleValue = (value) => {
        const newValues = selectedValues.includes(value)
            ? selectedValues.filter((v) => v !== value)
            : [...selectedValues, value];

        onChange(newValues);
    };

    const capitalize = (str) => (typeof str === 'string' ? str.charAt(0).toUpperCase() + str.slice(1) : '');

    return (
        <div className="row gutters-1">
            <div className="col-12">
                <ul className="list-group list-group-flush">
                    {options.map((option, index) => {
                        const id = uuidv1();
                        return (
                            <li key={index} className="list-group-item">
                                <div className="custom-control custom-checkbox position-relative">
                                    <input
                                        id={id}
                                        name={`${option.value}[]`}
                                        className="custom-control-input"
                                        type="checkbox"
                                        value={option.value}
                                        checked={selectedValues.includes(option.value)}
                                        onChange={() => toggleValue(option.value)}
                                    />
                                    <label className="custom-control-label d-flex align-items-center" htmlFor={id}>
                                <span className="custom-control-value">
                                    {nameMapping?.[option.value] || capitalize(option.label || option.value)}
                                </span>
                                        {showCount && option.count > 0 && (
                                            <span className="text--14 ml-auto mr-1">{option.count}</span>
                                        )}
                                    </label>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
}